module.exports = __webpack_public_path__ + "media/images/favicon/favicon-ff6e08d9b5723045c51d89b768658785.ico";